import { render, staticRenderFns } from "./Loaders.vue?vue&type=template&id=4f989914"
import script from "./Loaders.vue?vue&type=script&lang=js"
export * from "./Loaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports